import React from "react";
import tastyTreats from "../../assets/tasty-treats.svg";
import playtimeAlive from "../../assets/playtime-alive.svg";
import safeKidFriendly from "../../assets/safe-kid-friendly.svg";
import Shape from "../Shape/Shape";
import shape1 from "../../assets/shape1.svg";
import shape2 from "../../assets/shape2.svg";
import shape3 from "../../assets/shape3.svg";
import dotLine from "../../assets/dot-line.svg";
import "./SweetSection.css";

const SweetSection = () => {
  return (
    <>
      <div className="sweet-animation-section">
        <div className="sweet-semi-circle-animation"></div>
      </div>

      <section className="sweet-section">
        <h1>What Makes Us Sweet?</h1>
        <div className="sweet-content">
          <div className="sweet-item">
            <div className="sweet-star-container">
              <img src={tastyTreats} alt="Tasty & Irresistible Treats" />
            </div>
            <h2>Tasty & Irresistible Treats</h2>
          </div>
          <div className="sweet-item sweet-elevated">
            <div className="sweet-star-container">
              <img src={playtimeAlive} alt="Playtime Comes Alive" />
            </div>
            <h2>Playtime Comes Alive</h2>
          </div>
          <div className="sweet-item">
            <div className="sweet-star-container">
              <img src={safeKidFriendly} alt="Safe & Kid-Friendly" />
            </div>
            <h2>Safe & Kid-Friendly</h2>
          </div>
        </div>
        <img src={dotLine} alt="Dotted Line" className="sweet-dotted-line" />

        <Shape svgPath={shape1} className="sweet-shape1" />
        <Shape svgPath={shape2} className="sweet-shape2" />
        <Shape svgPath={shape3} className="sweet-shape3" />
      </section>
    </>
  );
};

export default SweetSection;
